/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hc_Domains_Step_3Inputs */

const en_hc_domains_step_3 = /** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain Verification. Once you update your records at your registrar (GoDaddy, Namecheap, etc.), click "Verify Connection" in the dashboard.`)
};

const es_hc_domains_step_3 = /** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificación del dominio. Una vez actualices tus registros en tu registrador (GoDaddy, Namecheap, etc.), haz clic en 'Verificar Conexión' en el panel.`)
};

const fr_hc_domains_step_3 = /** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérification du domaine. Une fois que vous avez mis à jour vos enregistrements chez votre registraire (GoDaddy, Namecheap, etc.), cliquez sur « Vérifier la connexion » dans le tableau de bord.`)
};

const de_hc_domains_step_3 = /** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain-Verifizierung. Sobald du deine Einträge bei deinem Registrar aktualisiert hast, klicke im Dashboard auf 'Verbindung überprüfen'.`)
};

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const ja_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const zh_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const ar_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const id_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const it_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const ru_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const pt_hc_domains_step_3 = en_hc_domains_step_3;

/** @type {(inputs: Hc_Domains_Step_3Inputs) => LocalizedString} */
const ko_hc_domains_step_3 = en_hc_domains_step_3;

/**
* | output |
* | --- |
* | "Domain Verification. Once you update your records at your registrar (GoDaddy, Namecheap, etc.), click \"Verify Connection\" in the dashboard." |
*
* @param {Hc_Domains_Step_3Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const hc_domains_step_3 = /** @type {((inputs?: Hc_Domains_Step_3Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hc_Domains_Step_3Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_hc_domains_step_3(inputs)
	if (locale === "es") return es_hc_domains_step_3(inputs)
	if (locale === "fr") return fr_hc_domains_step_3(inputs)
	if (locale === "de") return de_hc_domains_step_3(inputs)
	if (locale === "ja") return ja_hc_domains_step_3(inputs)
	if (locale === "zh") return zh_hc_domains_step_3(inputs)
	if (locale === "ar") return ar_hc_domains_step_3(inputs)
	if (locale === "id") return id_hc_domains_step_3(inputs)
	if (locale === "it") return it_hc_domains_step_3(inputs)
	if (locale === "ru") return ru_hc_domains_step_3(inputs)
	if (locale === "pt") return pt_hc_domains_step_3(inputs)
	return ko_hc_domains_step_3(inputs)
});